import './_submenu-image-links.scss';
import component from './submenu-image-links';

export default component;
